import script from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"

import "./BottomSheet.vue?vue&type=style&index=0&id=82b56d70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82b56d70"]])

export default __exports__